import api from "../../../api";

const BASE = "/api/mailbox";

/** The current user's mailbox connections (Gmail is always listed). */
export const getMailboxes = () => api.get(`${BASE}/`).then((r) => r.data);

/** Start Gmail consent: resolves to the Google URL to send the browser to. */
export const startGmailConnect = () =>
  api.post(`${BASE}/google/connect/`).then((r) => r.data.auth_url);

export const disconnectGmail = () =>
  api.post(`${BASE}/google/disconnect/`).then((r) => r.data);

/**
 * Send one email from the agent's connected Gmail. `formData` carries to / cc /
 * bcc, subject, body, attachments and client_key (one per email, so a retry or
 * a double click never sends a second copy).
 */
export const sendMailboxEmail = (formData) =>
  api.post(`${BASE}/send/`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
